// utils/cookies.ts
export function isRunningInsideIosWebView(): boolean {
    if (typeof document === 'undefined') return false; // SSR safeguard

    const regex = /(?:^|;\s*)app-platform=([^;]*)/;
    const match = regex.exec(document.cookie);
    return !!match;
}